import {Component, OnInit} from '@angular/core';
import {Blog} from '../shared/blog';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  isEditingMode = false;
  selectedBlog: Blog;

  constructor() {
  }

  ngOnInit() {
  }

  blogDetails(event) {
    console.log('admin component');
    console.log(event);
    this.selectedBlog = event;
    this.isEditingMode = true;
  }

  blogSaved() {
    console.log('hee');
    this.isEditingMode = false;
  }

}
